import { AnyAppEvent, AppEvent } from "../../appEvent.types";
import { z } from "zod";

const eventName = "open-event-website" as const;

export const OpenEventWebsiteEventDataSchema = z.object({
  eventId: z.string(),
});

export type OpenEventWebsiteEventData = z.infer<
  typeof OpenEventWebsiteEventDataSchema
>;

export type OpenEventWebsiteEvent = AppEvent<
  typeof eventName,
  OpenEventWebsiteEventData
>;

export const isOpenEventWebsiteEvent = (
  event: AnyAppEvent
): event is OpenEventWebsiteEvent => event.name === eventName;

export { eventName as openEventWebsite };
